export enum ViewMode {
    GridView = 'grid',
    ListView = 'list',
    ListLeftToRightView = 'list-ltr',
}
